import { render, staticRenderFns } from "./recipeContentAttributes.vue?vue&type=template&id=2adceef8&"
import script from "./recipeContentAttributes.vue?vue&type=script&lang=js&"
export * from "./recipeContentAttributes.vue?vue&type=script&lang=js&"
import style0 from "./recipeContentAttributes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports